module.exports = "/_next/static/media/e32b5e4d4d16fe73a7f92c6c6f59fbfa.svg";